<template>
	<el-time-picker
    class="smart-timePicker"
    v-model="currentValue"
    :picker-options="options"
    :is-range="isRange"
    :arrow-control="arrowControl"
    :placeholder="placeholder"
    :value-format="valueFormat"
    @change="changeValue">
  </el-time-picker>
</template>
<script>
import moment from 'moment'

export default {
  name: 'SmartTimePicker',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isRange: Boolean, // 是否是范围选择
    arrowControl: Boolean, // 是否为箭头滚动
    value: String || Number,
    placeholder: {
      type: String,
      default: '请选择时间'
    },
    dataType: {
      type: String,
      default: 'number'
    },
    valueFormat: {
      type: String,
      defalut: 'HH:mm:ss'
    }
  },
  computed: {
    currentValue: {
      get () {
        return this.value ? moment(this.value, 'HH:mm:ss').format() : ''
      },
      set (value) {
        this.$emit('input', moment(value).format('HH:mm:ss'))
      }
    }
  },
  methods: {
    changeValue (value) {
      this.$emit('changeValue', moment(value, 'HH:mm:ss').format())
    }
  }
}
</script>
<style scoped lang="sass">
.smart-timePicker
  width: 100%
  .el-input__inner
    border: 1px solid rgba(0, 0, 0, 0.07) !important
    color: #35495e
</style>



// WEBPACK FOOTER //
// SmartTimePicker.vue?6421dbb0